<script setup lang="ts">
    import toast from '../helpers/toast';

    const { t } = useI18n();

    const localePath = useLocalePath();
    const { locale } = useI18n();

    useHead({
        title: t('pages.contact.seoTitle'),
        htmlAttrs: { lang: locale.value },
        meta: [
            {  name: 'description', content: t('pages.contact.seoDescription') }
        ],
    });

    const name = ref("");
    const email = ref("");
    const message = ref("");
    const aceptarPolitica = ref(false);
    const nameError = ref("");
    const emailError = ref("");
    const messageError = ref("");

    const checkInputs = (event: any) => {
        nameError.value = name.value ? '' : t('pages.contact.requiredField');
        emailError.value = email.value ? '' : t('pages.contact.requiredField');
        messageError.value = message.value ? '' : t('pages.contact.requiredField');

        if (!name.value || !email.value || !message.value) {
            return false;
        }

        return true;
    }

    const submitForm = async (event: any) => {
    
        if (!checkInputs(event)) {
            toast("warning", t('pages.contact.requiredFieldsWarning'));
            return;
        }

        if (!aceptarPolitica.value) {
            toast("warning", t('pages.contact.privacyPolicyWarning'));
            return;
        }

        // Send form
        const { data: { value: { msgCode, msgType } } }: any = await useFetch(`/api/strapi/contact`, {
            lazy: true,
            server: false,
            method: 'POST',
            body: JSON.stringify({
                name: name.value,
                email: email.value,
                message: message.value,
                locale: locale.value
            })
        });
        
        // Show toast
        toast(msgType, t('api.' + msgCode));

        // Reset form
        if (msgType === "success") {
            name.value = "";
            email.value = "";
            message.value = "";
            aceptarPolitica.value = false;
        }
        
    };


</script>

<template>

    <NuxtLayout :name="'full-screen'">
        <div class="section-page-custom flex">
        
            <div class="page-custom-image" style="background-image: url('/img/contact_image.jpg')"></div>
            
            <div class="page-custom-wrap">
                <div class="page-custom-header">
                    <NuxtLink :to="localePath({ name: 'index' })">{{$t('goToHome')}}</NuxtLink>
                </div>
                <div class="page-custom-content flex">
                    <div class="subscribe-wrap contact-wrap">
                        <h3>{{ $t('pages.contact.title') }}</h3>
                        <div id="ityped-contact" class="ityped">
                            <span class="contact">{{ $t('pages.contact.subTitle') }}</span>
                        </div>
                        <form @submit.prevent="submitForm">

                            <div class="input">
                                <input class="subscribe-input contact-name" @focus="checkInputs" @blur="checkInputs" type="text" v-model="name" :placeholder="t('pages.contact.form.name')">
                                <div class="error">{{ nameError }}</div>
                            </div>

                            <div class="input">
                                <input class="subscribe-input contact-email" @focus="checkInputs" @blur="checkInputs" type="email" v-model="email" :placeholder="t('pages.contact.form.email')">
                                <div class="error">{{ emailError }}</div>
                            </div>

                            <div class="input">
                                <textarea class="subscribe-input contact-message" @focus="checkInputs" @blur="checkInputs" v-model="message" :placeholder="t('pages.contact.form.message')"></textarea>
                                <div class="error">{{ messageError }}</div>
                            </div>

                            <div class="privacy-checkbox">
                                <input type="checkbox" id="aceptarPolitica" v-model="aceptarPolitica">
                                <label for="aceptarPolitica">{{ $t('pages.contact.accept') }} <NuxtLink :to="localePath({ name: 'privacyPolicy' })" target="_blank">{{ $t('pages.contact.privacyPolicy') }}</NuxtLink></label>
                            </div>
                            <button class="global-button" type="submit">{{ $t('pages.contact.sendMessage') }}</button>
                        </form>
                    </div>
                </div>
                <div class="page-custom-footer">
                    <a href="https://thepoliticalroom.com">The Political Room.</a>
                    <span>Medio de comunicación independiente.</span>
                </div>
            </div>
        </div>

    </NuxtLayout>

</template>

<style scoped>

form {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-self: center;
}

form .input {
    width: 100%;
    margin-bottom: 50px;
}

.subscribe-wrap .subscribe-input {
    margin: 0;
}

.privacy-checkbox {
    display: flex;
    gap:10px;
    justify-content: center;
    margin-bottom: 30px;
}

.privacy-checkbox a {
    color: var(--ghost-accent-color);
}

.error {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}



</style>